import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import PlanHeatMap from './PlanHeatMap';

import { useGetPlanList } from 'hooks/InteractiveMap/useGetPlanList';

interface HeatMapsProps {
  startDate: string;
  endDate: string;
}

const HeatMaps: React.FC<HeatMapsProps> = ({ startDate, endDate }) => {
  const { t } = useTranslation();
  const { slug } = useParams();
  const { data: plans } = useGetPlanList(slug || '');
  return (
    <div className="row mt-2">
      <div className="row text-center">
        <h5 className="mb-2">
          <strong>{t('VisitReportsPDF.header.heatMap')}</strong>
        </h5>
      </div>
      <div className="row">
        <div className="d-flex flex-column gap-2">
          {plans?.map(plan => (
            <PlanHeatMap key={plan.slug} plan={plan} startDate={startDate} endDate={endDate} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeatMaps;
